import React from 'react';

const ModalContext = React.createContext({
  openModal: (type, props) => {},
  closeModal: () => {},
});

export default ModalContext;